<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Localización de la unidad</h5>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="map-container" *ngIf="mapUrl; else noLocation">
            <iframe
                    [src]="mapUrl"
                    frameborder="0"
                    allowfullscreen
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
            </iframe>
        </div>
        <ng-template #noLocation>
            <div class="alert alert-warning">
                No se han proporcionado coordenadas para mostrar la ubicación.
            </div>
        </ng-template>

        <!-- Botones de acción -->
        <div class="mt-3 d-flex justify-content-center gap-2" *ngIf="mapUrl">
            <button type="button" class="btn btn-secondary" (click)="refreshLocation()">
                <i class="bi bi-arrow-clockwise"></i> Actualizar ahora
            </button>
            <button type="button" class="btn btn-primary" (click)="openInGoogleMaps()">
                <i class="bi bi-geo-alt"></i> Abrir en Google Maps
            </button>
        </div>

        <!-- Indicador de última actualización -->
        <div class="mt-2 text-center text-muted small">
            <i class="bi bi-clock"></i> Actualización automática cada 60 segundos
        </div>
    </div>
</div>
